import classNames from "classnames";
import React, { FC, ReactNode } from "react";

import style from "./Heading.module.scss";

export interface HeadingProps {
  title: ReactNode;
  description: ReactNode;
  className?: string;
}

export const Heading: FC<HeadingProps> = ({ title, description, className }) => (
  <header className={classNames(style.root, className)}>
    <h1 className={style.title}>{title}</h1>
    <p className={style.description}>{description}</p>
  </header>
);

export default Heading;
